const htmlContent = `
<div id="markdown">
<h1 id="mptcp-linux-kernel-lücke-im-tcp-code">MPTCP: Linux-Kernel-Lücke im TCP-Code</h1>
<div class="video-poster">
<video controls preload="none" playsinline poster="/video/mptcp-thumbnail.jpg">
  <source src="/video/mptcp.mp4" type="video/mp4">
  <track kind="captions" src="/video/mptcp.vtt" srclang="de" label="Deutsch">
  Ihr Browser kann dieses Video nicht abspielen.
</video>
<button type="button" class="video-poster-play" aria-label="Video abspielen" onclick="var v = this.parentNode.querySelector('video'); this.remove(); v.play();"></button>
</div>

<p class="video-caption">Video vollständig mit KI erstellt (Bild und Stimme)</p>

<h2 id="die-lücke">Die Lücke</h2>
<p>Im Linux-Kernel gibt es eine neue Sicherheitslücke. Sie steckt im TCP-Code, beim Aufbau einer Verbindung. Berichten zufolge lässt sie sich über das Netz auslösen, ohne Anmeldung. Der Rechner stürzt dann ab, oder Speicher wird beschädigt.</p>
<p>Gezeigt wurde der Angriff über MPTCP, Multipath TCP. Damit läuft eine Verbindung über mehrere Wege, etwa WLAN und Mobilfunk. So haben Forscher im Labor Root-Rechte erlangt. Ob es auch ohne MPTCP geht, ist bisher nicht bekannt.</p>
<h2 id="ist-mein-rechner-betroffen">Ist mein Rechner betroffen?</h2>
<p>Ob Ihr Rechner betroffen ist, hängt an Ihrem Kernel. <code>uname -r</code> zeigt die Version.</p>
<p>Die Versionsnummer allein reicht nicht. Distributionen bauen Korrekturen auch in ältere Kernel ein. Maßgeblich ist der Sicherheitstracker Ihrer Distribution. Dort suchen Sie nach der Nummer der Lücke.</p>
<h2 id="läuft-mptcp">Läuft MPTCP?</h2>
<p>Möchten Sie wissen, ob MPTCP läuft? Das zeigt <code>sysctl net.mptcp.enabled</code>. Eins heißt an, null heißt aus. Meldet der Befehl einen Fehler, kennt Ihr Kernel kein MPTCP.</p>
<p>Eine Eins heißt nur: Der Kernel kann MPTCP. Für den gezeigten Angriff muss außerdem ein Dienst MPTCP annehmen.</p>
<h2 id="was-tun">Was tun?</h2>
<p>Die Lösung ist das Kernel-Update Ihrer Distribution. Danach starten Sie neu. Stand Ende Oktober hat Debian es ausgeliefert. Bei Ubuntu und Red Hat fehlt es noch.</p>
<p>Bis dahin können Sie MPTCP ausschalten: <code>sysctl -w net.mptcp.enabled=0</code>. Das verkleinert die Angriffsfläche. Die Lücke schließt es nicht.</p>

</div>
`;
export default htmlContent
